import React, { useEffect, useState } from "react";
import { useAuth0Params } from "../hooks/useAuth0Params";
import GenericModal from "@ui-components/Modal/GenericModal";
import GenericButton from "@ui-components/Button/GenericButton";
import { ReactComponent as IconCheck } from "../assets/Icons/Icon_Success.svg";
import { ReactComponent as IconWarning } from "../assets/Icons/Icon_Warning.svg";

const Auth0RedirectHandler: React.FC = () => {
  const { success, message } = useAuth0Params();
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    //The modal opens if both are non-null
    if (message !== undefined && success !== null) {
      setIsOpen(true);
      //Strip off ?message=…&success=… so it won’t reappear
      const { protocol, host, pathname } = window.location;
      window.history.replaceState({}, "", `${protocol}//${host}${pathname}`);
    }
  }, [message, success]);

  const handleClose = () => {
    setIsOpen(false);
    window.location.href = "/login";
  };

  return (
    <GenericModal
      isOpen={isOpen}
      onClose={handleClose}
      blurBackdrop
      size="sm"
      closeOnBackdropClick={false}
    >
      <div className="flex flex-col items-left px-4">
        {/* Icon + Title */}
        <div className="flex items-center space-x-2">
          {success ? (
            <IconCheck
            className="w-6 h-6 text-[var(--color-primitive-green-600)]"
            />
          ) : (
            <IconWarning
            className="w-6 h-6 text-[var(--color-primitive-red-700)]"
            />
          )}
          <h2
            className={"text-xl font-semibold"}
          >
            {success ? "Success" : "Error"}
          </h2>
        </div>

        {/* Message */}
        <p             
            className={`my-5 font-semibold ${
                success
                ? "text-[var(--color-primitive-green-600)]"
                : "text-[var(--color-primitive-red-700)]"
            }`}
            >{message}</p>

        {/* Close Button */}
        <div className="w-1/2 mx-auto">
            <GenericButton
            label="Close"
            variant="brand"
            onClick={handleClose}
            style={{
                width: "100%", 
                backgroundColor: "black",
              }}
            />
        </div>
      </div>
    </GenericModal>
  );
};

export default Auth0RedirectHandler;
